import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BottomNavigation from '../components/BottomNavigation';
import './ForgotPassword.css';

const ForgotPassword: React.FC = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState<'email' | 'otp' | 'newPassword'>('email');
  const [emailOrPhone, setEmailOrPhone] = useState('');
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const handleOtpChange = (index: number, value: string) => {
    if (value.length > 1) return;
    if (!/^\d*$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 5) {
      const nextInput = document.getElementById(`otp-input-${index + 1}`);
      nextInput?.focus();
    }
  };

  const handleSubmitEmail = (e: React.FormEvent) => {
    e.preventDefault();
    // Send OTP logic
    setStep('otp');
  };

  const handleSubmitOtp = (e: React.FormEvent) => {
    e.preventDefault();
    const otpCode = otp.join('');
    if (otpCode.length === 6) {
      // Verify OTP logic
      setStep('newPassword');
    }
  };

  const handleSubmitNewPassword = (e: React.FormEvent) => {
    e.preventDefault();
    if (newPassword === confirmPassword && newPassword.length >= 6) {
      // Reset password logic
      navigate('/login');
    }
  };

  return (
    <div className="forgot-password-page">
      <header className="forgot-password-header">
        <button className="back-button" onClick={() => navigate('/login')}>
          ←
        </button>
        <h1>Reset Password</h1>
        <div className="header-spacer"></div>
      </header>

      <div className="forgot-password-content">
        {step === 'email' && (
          <div className="step-content">
            <div className="step-icon">🔐</div>
            <h2>Forgot Password?</h2>
            <p className="step-description">
              Enter your email or phone number and we'll send you a verification code
            </p>
            <form onSubmit={handleSubmitEmail} className="forgot-password-form">
              <div className="form-group">
                <label>Email or Phone Number</label>
                <input
                  type="text"
                  placeholder="Enter email or phone"
                  value={emailOrPhone}
                  onChange={(e) => setEmailOrPhone(e.target.value)}
                  required
                />
              </div>
              <button type="submit" className="submit-button">
                Send Verification Code
              </button>
            </form>
          </div>
        )}

        {step === 'otp' && (
          <div className="step-content">
            <div className="step-icon">📱</div>
            <h2>Enter Verification Code</h2>
            <p className="step-description">
              We've sent a 6-digit code to {emailOrPhone}
            </p>
            <form onSubmit={handleSubmitOtp} className="otp-form">
              <div className="otp-inputs">
                {otp.map((digit, index) => (
                  <input
                    key={index}
                    id={`otp-input-${index}`}
                    type="text"
                    inputMode="numeric"
                    maxLength={1}
                    value={digit}
                    onChange={(e) => handleOtpChange(index, e.target.value)}
                    className="otp-input"
                    autoFocus={index === 0}
                  />
                ))}
              </div>
              <button type="submit" className="submit-button">
                Verify Code
              </button>
              <button
                type="button"
                className="resend-button"
                onClick={() => {
                  // Resend OTP logic
                  setOtp(['', '', '', '', '', '']);
                }}
              >
                Resend Code
              </button>
            </form>
          </div>
        )}

        {step === 'newPassword' && (
          <div className="step-content">
            <div className="step-icon">🔑</div>
            <h2>Create New Password</h2>
            <p className="step-description">
              Please enter your new password
            </p>
            <form onSubmit={handleSubmitNewPassword} className="new-password-form">
              <div className="form-group">
                <label>New Password</label>
                <input
                  type="password"
                  placeholder="Enter new password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required
                  minLength={6}
                />
              </div>
              <div className="form-group">
                <label>Confirm Password</label>
                <input
                  type="password"
                  placeholder="Confirm new password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                  minLength={6}
                />
              </div>
              {newPassword && confirmPassword && newPassword !== confirmPassword && (
                <p className="error-message">Passwords do not match</p>
              )}
              <button 
                type="submit" 
                className="submit-button"
                disabled={newPassword !== confirmPassword || newPassword.length < 6}
              >
                Reset Password
              </button>
            </form>
          </div>
        )}
      </div>

      <BottomNavigation />
    </div>
  );
};

export default ForgotPassword;
